import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const RESIDENTIALPRICEDIFF_LAYER_ID = 'residentialPriceDiffLayer';

const layerConfig = {
  title: 'Residential Price Difference',
};

function ResidentialPriceDiffLayer() {
  const dispatch = useDispatch();
  const { residentialPriceDiffLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, residentialPriceDiffLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (residentialPriceDiffLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: RESIDENTIALPRICEDIFF_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: residentialPriceDiffLayer.visible,
      opacity: residentialPriceDiffLayer.opacity,
      getFillColor: colorBins({
        attr: 'residential_price_diff',
        domain: [-504714, -1000, -10, 0, 5.93, 94.75, 253033],
        colors: [
          [178, 34, 34],
          [255, 0, 0],
          [255, 102, 102],
          [255, 204, 204],
          [224, 224, 255],
          [153, 204, 255],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: RESIDENTIALPRICEDIFF_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['residential_price_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default ResidentialPriceDiffLayer;
